
import React from 'react';
import { Calendar, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';


interface ZeegBookingButtonProps {
  className?: string;
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'xl' | 'icon' | 'mobile' | 'tablet';
  text?: string;
  zeegProfileUrl?: string;
}

const ZeegBookingButton: React.FC<ZeegBookingButtonProps> = ({
  className,
  variant = 'default',
  size = 'default',
  text = 'Jetzt Erstgespräch vereinbaren',
  zeegProfileUrl = 'https://zeeg.me/joerghoermann'
}) => {
  return (
    <button
      className={cn(
        "relative mx-auto flex items-center justify-center gap-3 transition-all duration-300 rounded-full px-6 py-4 font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-joerg-400/50 hover:shadow-lg hover:scale-105 group", 
        className
      )}
      onClick={() => {
        window.open(zeegProfileUrl, '_blank', 'noopener,noreferrer');
      }}
      aria-label="Termin buchen"
    >
      <Calendar className="h-5 w-5 transition-transform group-hover:scale-110" />
      <span className="relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-current after:transition-all group-hover:after:w-full">{text}</span>
      <ExternalLink className="h-4 w-4 ml-1 transition-all group-hover:translate-x-1" />
    </button>
  );
};

export default ZeegBookingButton;
